import classes from "./BaseTable.module.css";
import React, { useState } from "react";
import { Pagination } from "../Pagination";
import { StatusMessage } from "../../statusMessage/StatusMessage";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export function BaseTable({
  columns = [],
  columnAndRowWidth,
  rows = [],
  onClick,
  rowStyle,
  isSelected,
  hoverElements = [],
  status,
  items,
  errorMsg,
  noItemsMsg,
  currentPage,
  setCurrentPage,
  totalPages,
  totalFilteredPages,
  isFiltered,
  pagination = false,
  header,
  filters,
  resultsContainerHeight,
  tableStyle,
  containerWidth,
  underRowsElements,
}) {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { language } = useSelector((state) => state.global);
  const location = useLocation();

  return (
    <div
      className={`${classes.container} fadeInTranslate`}
      style={{ width: containerWidth ? containerWidth : "" }}
    >
      <div className={classes.table} style={tableStyle}>
        {header && <h5>{header}</h5>}
        {filters && <div className={classes.filters}>{filters}</div>}
        <div className={`${classes.tableHeader} fadeInTranslate`}>
          {columns.map((col, index) => (
            <span key={index} style={{ width: columnAndRowWidth }}>
              {col.label}
            </span>
          ))}
        </div>

        <div
          className={classes.rows}
          style={{
            height: resultsContainerHeight ? resultsContainerHeight : "",
          }}
        >
          {status !== "loading" &&
            rows.map((rowData, rowIndex) => (
              <div
                key={rowIndex}
                className={`${classes.row} ${
                  isSelected === rowIndex ? classes.selected : ""
                } fadeInTranslate`}
                onClick={() => onClick?.(rowIndex)}
                style={rowStyle}
                onMouseEnter={() => setHoveredIndex(rowIndex)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className={classes.flexRow}>
                  {rowData.map((cell, cellIndex) => {
                    const isReactElement = React.isValidElement(cell);
                    const isStatusChip =
                      isReactElement && cell.type?.name === "StatusChip";

                    let bottomValue;

                    if (rowIndex === rows.length - 1 && isStatusChip) {
                      if (
                        location.pathname === "/dashboard" &&
                        cellIndex === rowData.length - 1
                      ) {
                        bottomValue = "0";
                      } else if (
                        location.pathname === "/deliveries" &&
                        cellIndex === rowData.length - 2
                      ) {
                        bottomValue = "0";
                      }
                    }

                    return isReactElement ? (
                      <div
                        key={cellIndex}
                        style={{
                          width: columnAndRowWidth,
                          position: "relative",
                        }}
                        className={classes.cellWrapper}
                        onMouseEnter={() =>
                          isStatusChip &&
                          setHoveredIndex({ row: rowIndex, cell: cellIndex })
                        }
                        onMouseLeave={() =>
                          isStatusChip && setHoveredIndex(null)
                        }
                      >
                        {cell}
                        {isStatusChip &&
                          hoveredIndex?.row === rowIndex &&
                          hoveredIndex?.cell === cellIndex &&
                          cell.props.hoverText && (
                            <div
                              className={`${classes.hoverTextContainer} fadeInTranslate`}
                              style={{
                                bottom: bottomValue,
                                right:
                                  location.pathname === "/dashboard"
                                    ? "150px"
                                    : "",
                              }}
                            >
                              <h4>{language === "en" ? "Note:" : "Merk:"}</h4>
                              <p>{cell.props.hoverText}</p>
                            </div>
                          )}
                      </div>
                    ) : (
                      <span
                        key={cellIndex}
                        style={{ width: columnAndRowWidth }}
                        title={cell}
                        className={classes.textClamp}
                      >
                        {cell}
                      </span>
                    );
                  })}
                </div>

                {(hoveredIndex === rowIndex ||
                  hoveredIndex?.row === rowIndex) &&
                  hoverElements[rowIndex] && (
                    <div className={classes.hoverElements}>
                      {hoverElements[rowIndex]}
                    </div>
                  )}
              </div>
            ))}

          <StatusMessage
            status={status}
            items={items}
            text={{
              errorFetching: errorMsg,
              noItemsFound: noItemsMsg,
            }}
          />
        </div>
        {underRowsElements && <>{underRowsElements}</>}
        {items.length !== 0 && status !== "loading" && pagination && (
          <div className={classes.paginationContainer}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
              filteredPages={totalFilteredPages}
              isFiltered={isFiltered}
            />
          </div>
        )}
      </div>
    </div>
  );
}
